export default __webpack_public_path__ + "static/media/walletIcon.62d0c2c6.svg";